module.exports = __webpack_public_path__ + "img/官网-证书-国贸安卓APP.b3aaf30d.png";